module.exports = __webpack_public_path__ + "static/media/logo_pl.42c474b6.png";